import { makeStyles } from "@mui/styles";

export default makeStyles(theme => ({
  button: {
    outline: 0,
    borderRadius: 8,
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 16,
    paddingRight: 16,
    textTransform: "none",
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: -0.1,
    boxSizing: "border-box",
    display: "flex",
    gap: 5,
    alignItems: "center",
    justifyContent: "center"
  },
  buttonsm: {
    width: 142,
    height: 39
  },
  buttonmd: {
    width: 150,
    height: 45
  },
  buttonlg: {
    width: 180,
    height: 54
  },
  buttonfluid: {
    height: 39
  },
  buttonfull: {
    width: "100%",
    height: 54
  },
  primary: {
    backgroundColor: theme.palette.primary.main,
    border: `0px solid ${theme.palette.primary.main}`
  },
  primaryOutline: {
    backgroundColor: "white",
    border: "1.5px solid #101928"
  },
  dangerOutline: {
    backgroundColor: "white",
    border: "1.5px solid #CB1A14"
  },
  success: {
    backgroundColor: "#036B26",
    border: "1.5px solid #036B26"
  },
  btnsuccess: {
    color: "#036B26"
  },
  danger: {
    backgroundColor: "#CB1A14",
    border: "0px solid #CB1A14"
  },
  btnwhite: {
    color: "white"
  },
  btnblack: {
    color: "black"
  },
  btndanger: {
    color: "#CB1A14"
  },
  btnfontprimary: {
    color: theme.palette.primary.main
  }

}));
